import { CookieManager } from '@account-service/core'
import { SHA256 } from 'crypto-js'

export const cookieManager = CookieManager('dashboard')

export const hashPassword = (pwd: string) => SHA256(pwd).toString()

export * from './device'
